import Vue from "vue";
import {MusicXmlImport} from '../models/ImportMusicxmlTypes';
import { BackEndService } from "../../../utils/BackEndService";
import { analyticsController } from "../../user/analytics/AnalyticsController";
import { Notify } from "quasar";

interface MusicXmlImportControllerState {
  currentImport: MusicXmlImport | null,
  isLoading: boolean,
  isSendEmailLoading?: boolean,
}

class MusicXmlImportController {
  public readonly state = Vue.observable<MusicXmlImportControllerState>({
    currentImport: null,
    isLoading: false,
    isSendEmailLoading: false
  })

  public fetch(isRefresh = false) {
    if(!isRefresh) {
      this.state.isLoading = true;
    }
    return BackEndService.sendGetRequest('piece/musicxml/import-step').then((response) => {
      this.state.currentImport = response.data as MusicXmlImport | null;
    })
    .finally(() => {
      if(!isRefresh) {
        this.state.isLoading = false;
      }
    })
  }

  public read() {
    if(!this.state.currentImport) {
      return
    }
    return BackEndService.sendPatchRequest(`piece/musicxml/import-step/${this.state.currentImport.id}/read`).then(() => {
      this.fetch();
    })
  }

  public sendEmail(importError?: string) {
    this.state.isSendEmailLoading = true;

    analyticsController.logBasicAnalyticsEvent('requested help email', 'Import Piece Events', {
      errorMessage: importError || this.state.currentImport?.failed_reason || 'No error message available',
    });

     BackEndService.sendPostRequest('piece/musicxml/help-email', {
      importError: importError || this.state.currentImport?.failed_reason || 'No error message available',
    })
      .then(() => {
        analyticsController.logBasicAnalyticsEvent('help email sent', 'Import Piece Events');
        Notify.create({
          type: 'positive',
          message: "Un email d'assistance vous a été envoyé avec des instructions pour vous aider.",
        });
      })
      .catch(() => {
        analyticsController.logBasicAnalyticsEvent('help email error', 'Import Piece Events');
        Notify.create({
          type: 'negative',
          message: "Une erreur est survenue lors de l'envoi de l'email d'assistance.",
        });
      })
      .finally(() => {
        this.state.isSendEmailLoading = false;
      });
  }
}

export const musicXmlImportController = new MusicXmlImportController();